import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import Typography from 'material-ui/Typography';

import TreeNodeModel from 'models/TreeNode';

import styles from 'styles/components/list/NodePrimaryText';

import Code from 'components/Code';

@withStyles(styles)
@observer
export default class NodePrimaryText extends Component {

  static propTypes = {
    node: PropTypes.instanceOf(TreeNodeModel).isRequired
  }

  render() {
    const { node, classes } = this.props;

    if (node.code)
      return (
        <Typography
          variant='subheading'
          className={ classes.code }
        >
          Код <span className={ classes.codeNumber }>{ <Code code={node.code} /> }</span>
        </Typography>
      );
    else return '';
  }

}



// WEBPACK FOOTER //
// ./src/components/list/NodePrimaryText.js